

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { StateSetup } from "../../components/StateSetup";


export const StateSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="State Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "State Setup", navigateTo: "/state/setup" }
      ]}
      mainContents={<StateSetup />}
    />
  );
};
